import React, { useEffect, useState } from "react";
import DataTable from "../../../components/DataTable/DataTable";
import {
	AssetRegistrationHeader,
	CompletedLeaseHeader,
	CreatedAssetsHeader,
	InsuranceHeader,
	InvestorLeaseHeader,
	OngoingLeaseHeader,
	RequestLeaseHeader,
	SavingsHeader,
} from "../data";
import DeleteIcon from "../../../assets/icons/deleteIcon.svg";
// import ExportIcon from "../../../assets/icons/exportIcon.svg";
import { TableButton, TableToolbar } from "../../../components/DataTable/DataTable.styles";
import { Select, MenuItem } from "@mui/material";
import ConfirmModal from "../../../components/ConfirmModal";
import { getFilteredTableData } from "../../../utils/Utils";
import { canPerformAction } from "../../../utils/UserAuth";

/* eslint-disable react/prop-types */
const LeaseDataTable = ({ currentTab, TableData, handleDeleteLease, filter }) => {
	const [TableHeadCells, setTableHeadCells] = useState(OngoingLeaseHeader);
	const [selectedItems, setSelectedItems] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [dateFilter, setDateFilter] = useState("All");
	const [filteredData, setFilteredData] = useState([]);

	useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [TableData]);

	useEffect(() => {
		setCurrentTableHeader();
	}, [currentTab, filter]);

	const setCurrentTableHeader = () => {
		let TableHeader = [];
		if (currentTab === "ongoing") {
			TableHeader = OngoingLeaseHeader;
		} else if (currentTab === "submitted") {
			TableHeader = RequestLeaseHeader;
		} else if (currentTab === "completed" && filter === "asset_registration") {
			// console.log(currentTab, filter, 2);
			TableHeader = AssetRegistrationHeader;
		} else if (currentTab === "completed" && filter === "insurance") {
			// console.log(currentTab, filter, 2, "insurance");
			TableHeader = InsuranceHeader;
		} else if (currentTab === "completed" && filter !== "asset_registration") {
			// console.log(currentTab, filter, 2);
			TableHeader = CompletedLeaseHeader;
		} else if (currentTab === "completed" && filter !== "insurance") {
			// console.log(currentTab, filter, 2);
			TableHeader = CompletedLeaseHeader;
		} else if (currentTab === "created_assets") {
			TableHeader = CreatedAssetsHeader;
		} else if (currentTab === "savings") {
			TableHeader = SavingsHeader;
		} else {
			TableHeader = InvestorLeaseHeader;
		}

		setTableHeadCells(TableHeader);
	};

	// console.log(TableHeadCells);

	const handleDateFilterChange = (e) => {
		// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, TableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
	};

	const handleDeleteAction = () => {
		console.log("selected", selectedItems);
		setConfirmModal(false);
		handleDeleteLease(selectedItems);
	};

	const LeaseTableToolbar = ({ selected }) => {
		return (
			<TableToolbar>
				<div className='_notification'>{filteredData.length} Item(s) Found</div>

				<div className='_buttons'>
					{/* {currentTab !== "created_assets" && (
						<Select value={currentFilter} className='toolbarSelect' onChange={(e) => handleFilterChange(e)}>
							<MenuItem value='all'>All</MenuItem>
							<MenuItem value='personal_business'>Personal / Business</MenuItem>
							<MenuItem value='investor'>Investor</MenuItem>
						</Select>
					)} */}

					<Select value={dateFilter} className='toolbarSelect' onChange={(e) => handleDateFilterChange(e)}>
						<MenuItem value='Today'>Today</MenuItem>
						<MenuItem value='Week'>Last 7 days</MenuItem>
						<MenuItem value='Month'>Last 30 days</MenuItem>
						<MenuItem value='6 Months'>Last 6 months</MenuItem>
						<MenuItem value='Year'>Last 12 months</MenuItem>
						<MenuItem value='All'>All Time</MenuItem>
					</Select>

					{canPerformAction("delete", "lease") && (
						<TableButton
							variant='outlined'
							color='error'
							onClick={() => {
								setSelectedItems(selected);
								setConfirmModal(true);
							}}>
							<img src={DeleteIcon} alt='' />
						</TableButton>
					)}

					{/* <TableButton variant='outlined' color='primary'>
						<img src={ExportIcon} alt='' />
					</TableButton> */}
				</div>
			</TableToolbar>
		);
	};

	return (
		<>
			<DataTable TableData={filteredData} headCells={TableHeadCells} TableToolbar={LeaseTableToolbar} />
			{currentTab === "submitted" && (
				<div style={{ fontWeight: 500, fontSize: "14px", marginTop: "1rem", display: "grid", gap: "5px" }}>
					<p>
						<span style={{ color: "red" }}>*</span> <span>One lease request on assets created by Admin</span>
					</p>
					<p>
						<span style={{ color: "blue" }}>*</span>{" "}
						<span>One lease request on assets created by Investor(s)</span>
					</p>
					<p>
						<span style={{ color: "red" }}>*2+</span>{" "}
						<span>More than one lease request on assets created by Admin</span>
					</p>
					<p>
						<span style={{ color: "blue" }}>*2+</span>{" "}
						<span>More than one lease request on assets created by Investor(s)</span>
					</p>
					<p>
						<span style={{ fontWeight: 600 }}>NB: </span>Only one request can be approved for requests with
						the same Asset ID
					</p>
				</div>
			)}
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: "Delete Lease",
						desc: "Are you sure you want to delete this lease(s)?",
						btnText: "Yes, Delete",
					}}
					handleDeleteAction={handleDeleteAction}
				/>
			)}
		</>
	);
};

export default LeaseDataTable;
